
import React from "react";

export function DateFormatter(cellContent,row){

    return(
        <>
            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                {`${row.submissionDate}`}
            </span>
        </>
    )
}